import styles from "./Interest.module.css"

export default function Interest({item, isSelected, onClick}) 
{
    return (
    <div className={styles.Main + ( isSelected ? " " + styles.selected : "" ) + ( onClick ? " " + styles.clickable : "" )} onClick={onClick}>
        <div className={styles.PictureBlock}><img src={item.imageUrls?.original_s} alt="logo"/></div>
        <div className={styles.Title}>{item.title}</div>
    </div>)
}